import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import { esTu } from "./clerk-es";
import App from "./App";
import Salvavidas from "./piezas/Salvavidas";
import "./estilo.css";

/**
 * UN SOLO SITIO: studio.humanink.io (Rais, 23-sep, al ver «humanink-studio.pages.dev/#/sso-callback»).
 *
 * Cloudflare Pages sirve la web también en su dominio crudo. Entrar por ahí parece lo mismo y no lo
 * es: la sesión de la cuenta es POR DOMINIO, así que quien entra en pages.dev se queda con una
 * sesión que no vale en el sitio de verdad —el que abre la aplicación instalada—, y la vuelta de
 * Google acaba en un dominio que el autor no reconoce. Se manda al sitio bueno conservando la ruta.
 *
 * Los despliegues de prueba («a97fc014.humanink-studio.pages.dev») NO se tocan: son míos, para mirar
 * una versión antes de publicarla, y redirigirlos me dejaría sin forma de verla.
 */
const CANONICO = "studio.humanink.io";
// ENCENDIDO el 24-sep con Clerk de producción: su sesión solo vale en humanink.io y sus subdominios,
// así que en pages.dev ya no se puede ni entrar. El proyecto y el manuscrito abiertos los guarda el
// motor (P-01): cambiar de dominio ya no obliga a elegirlos otra vez.
const REDIRIGIR = true;
if (REDIRIGIR && location.hostname === "humanink-studio.pages.dev") {
  location.replace(`https://${CANONICO}${location.pathname}${location.search}${location.hash}`);
}

// Las cuentas del Editor Studio (Clerk, desde el 11-sep-2026). La clave PUBLICABLE la lee el SDK de
// VITE_CLERK_PUBLISHABLE_KEY; la secreta no existe en la web. Las pantallas de Clerk, en español de tú.
createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <ClerkProvider localization={esTu} afterSignOutUrl="/">
      <Salvavidas entero>
        <App />
      </Salvavidas>
    </ClerkProvider>
  </StrictMode>,
);
